// config.js

// export const baseUrl = 'https://pc.schoolface.cn';//正式环境
// export const baseUrl = 'http://124.251.111.26:8084';//测试环境

export const baseUrl = '';//打包使用.aaa


// WEBPACK FOOTER //
// ./src/api/config.js